<template>
  <div class="tv">
    <div class="teamsContainer" :style="'grid-template-columns: repeat(' + teams.length + ', 1fr)'">
      <div v-for="team in teams" class="team" v-bind:key="team.id">
        <div class="teamTitle" :style="'background-color: ' + team.color">
          Equipe {{team.name}}
        </div>
        <div class="teamPlayers">
          <p v-for="player in team.players" v-bind:key="player.id" class="playerInTeam">
            {{player.name}}
            <span v-if="top1Player(player)" class="tag top1tag">1er ({{getStat(0)}})</span>
            <span v-if="top2Player(player)" class="tag top2tag">2e ({{getStat(1)}})</span>
            <span v-if="top3Player(player)" class="tag top3tag">3e ({{getStat(2)}})</span>
            <span v-if="top4Player(player)" class="tag top4tag">4e ({{getStat(3)}})</span>
            <span v-if="top5Player(player)" class="tag top5tag">5e ({{getStat(4)}})</span>
            <span v-if="isMostEnduringPlayer(player)" class="animal-emoji">🐆</span>
            <span v-if="isMostLazyPlayer(player)" class="animal-emoji">🦥</span>
            <span v-if="isMostEffectivePlayer(player)" class="animal-emoji">🦅</span>
          </p>
        </div>
        <div class="teamScore">
          <div class="setScore">{{team.setScore}}</div>
          <div class="pointScore">{{team.pointScore}}</div>
          <div class="nbMatchPlayed">{{team.nbPlayedMatches}} <br/>matchs joués</div>
        </div>
      </div>
    </div>

    <div class="matchesContainer">
      <div class="matchesColumn previousMatches">
        <h2>Derniers matchs joués</h2>
        <Match v-if="lastPlayedMatchTable1" :match="lastPlayedMatchTable1"/>
        <Match v-if="lastPlayedMatchTable2" :match="lastPlayedMatchTable2"/>
      </div>
      <div class="matchesColumn">
        <h2>Matchs en cours</h2>
        <Match v-if="currentMatchTable1" :match="currentMatchTable1"/>
        <Match v-if="currentMatchTable2" :match="currentMatchTable2"/>
      </div>
      <div class="matchesColumn nextMatches">
        <h2>Prochains matchs</h2>
        <Match v-if="nextMatchTable1" :match="nextMatchTable1" />
        <Match v-if="nextMatchTable2" :match="nextMatchTable2" />
      </div>
    </div>

    <div class="progressbarwrapper">
      <div class="progressbar" :style="progressbarWidth"><span v-if="displayNbPlayedMatchesInProgressBar">{{nbPlayedMatches}} / {{nbMatches}} matchs joués</span></div>
      <div class="progressbar-text" v-if="!displayNbPlayedMatchesInProgressBar">{{nbPlayedMatches}} / {{nbMatches}} matchs joués</div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import Match from "@/components/Match.vue";
import axios from "axios";
import * as Stomp from 'stompjs';

export default {
  name: "tv",
  components: {
    Match
  },
  computed: {
    teams() {
      return this.$store.state.teams.sort((a, b) => {
        var diff = b.setScore - a.setScore;
        if (diff === 0){
          diff = b.pointScore - a.pointScore;
        }
        return diff;
      });
    },
    lastPlayedMatchTable1(){
      var tables = this.$store.state.tables.filter(table => table.number === 1);
      if (tables.length === 1){
        return tables[0].lastPlayedMatch;
      }
      return null;
    },
    lastPlayedMatchTable2(){
      var tables = this.$store.state.tables.filter(table => table.number === 2);
      if (tables.length === 1){
        return tables[0].lastPlayedMatch;
      }
      return null;
    },
    currentMatchTable1(){
      var tables = this.$store.state.tables.filter(table => table.number === 1);
      if (tables.length === 1){
        return tables[0].currentMatch;
      }
      return null;
    },
    currentMatchTable2(){
      var tables = this.$store.state.tables.filter(table => table.number === 2);
      if (tables.length === 1){
        return tables[0].currentMatch;
      }
      return null;
    },
    nextMatchTable1(){
      var tables = this.$store.state.tables.filter(table => table.number === 1);
      if (tables.length === 1){
        return tables[0].nextMatch;
      }
      return null;
    },
    nextMatchTable2(){
      var tables = this.$store.state.tables.filter(table => table.number === 2);
      if (tables.length === 1){
        return tables[0].nextMatch;
      }
      return null;
    },
    nbPlayedMatches(){
      var matches = this.$store.state.matches;
      if (matches){
        return matches.filter(match => match.score !== null && (match.score.leftScore + match.score.rightScore) !== 0).length;
      }
      return 0;
    },
    nbMatches(){
      var matches = this.$store.state.matches;
      if (matches){
        return matches.length;
      }
      return 120;
    },
    progressbarWidth(){
      return "width:" + Math.round(this.nbPlayedMatches / this.nbMatches * 100) + "%;";
    },
    displayNbPlayedMatchesInProgressBar(){
      return Math.round(this.nbPlayedMatches / this.nbMatches * 100) >= 50;
    }
  },
  methods: {
    teamsColor(id) {
      return 'background-color: ' + this.$store.state.teamsColor.get(id);
    },
    top1Player(player){
      return this.$store.state.stats[0] && this.$store.state.stats[0].player.id === player.id
    },
    top2Player(player){
      return this.$store.state.stats[1] && this.$store.state.stats[1].player.id === player.id
    },
    top3Player(player){
      return this.$store.state.stats[2] && this.$store.state.stats[2].player.id === player.id
    },
    top4Player(player){
      return this.$store.state.stats[3] && this.$store.state.stats[3].player.id === player.id
    },
    top5Player(player){
      return this.$store.state.stats[4] && this.$store.state.stats[4].player.id === player.id
    },
    getStat(index){
      return this.$store.state.stats[index].matchSetWonMinusMatchSetLost + '/' + this.$store.state.stats[index].pointsWonMinusPointsLost
    },
    isMostEnduringPlayer(player) {
      const mostEnduringPlayer = (this.$store.state.stats.length > 0) ? this.$store.state.stats.reduce((x, y) => (x.pointsPlayed - y.pointsPlayed > 0) ? x : y) : ""
      return mostEnduringPlayer.player.id === player.id
    },
    isMostLazyPlayer(player) {
      const mostLazyPlayer = (this.$store.state.stats.length > 0) ? this.$store.state.stats.reduce((x, y) => (x.pointsPlayed - y.pointsPlayed < 0) ? x : y) : ""
      return mostLazyPlayer.player.id === player.id
    },
    isMostEffectivePlayer(player) {
      const mostEffectivePlayer = (this.$store.state.stats.length > 0) ? this.$store.state.stats.reduce((x, y) => ((x.pointsWonMinusPointsLost) - (y.pointsWonMinusPointsLost) > 0) ? x : y) : ""
      return mostEffectivePlayer.player.id === player.id
    }

  }
};
</script>
<style scoped>
.tv{
  width: 95%;
  margin: auto;
}
.teamsContainer{
  display: grid;
  margin-top: 20px;
  margin-bottom: 20px;
}
.team{
  box-shadow: 0.1em 0.3em 0.4em #ddd;
  margin-left : 10px;
  margin-right: 10px;
}
.teamTitle{
  height: 50px;
  line-height: 50px;
  text-align: center;
  font-weight: normal;
  color: #404040;
  font-size: 1.5em;
}
.teamPlayers{
  margin: 20px;
  margin-bottom: 0px;
  margin-top: 5px;
  border-bottom: 1px solid #ddd;
}
.teamPlayers p{
  margin: 0px;
  padding-bottom: 5px;
  font-size: 1.1em;
}
.teamScore{
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  text-align: center;
}
.setScore{
  color: #404040;
  font-size: 4em;
  font-weight: bold;
  margin-top: 10px;
}
.pointScore{
  color: #aaa;
  font-size: 2em;
  font-weight: bold;
  margin-top: 32px;
  margin-bottom: 32px;
  border-right: 1px solid #ddd;
}
.nbMatchPlayed{
  color: #404040;
  font-size: 1.5em;
  font-weight: bold;
  margin-top: 20px;
  margin-bottom: 20px;
  padding-left: 5px;
  padding-right: 5px;
}


.matchesContainer{
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  color: #404040;
}
.matchesColumn{
  padding-left: 10px;
  padding-right: 10px;
  text-align: center;
}
.previousMatches{
  border-right: 1px solid #ddd;
}
.nextMatches{
  border-left: 1px solid #ddd;
}


.progressbarwrapper{
  border-radius:20px;
  height:40px;
  padding:0px;
  background-color: #ddd;
  margin-top: 20px;
}
.progressbar{
  border-radius:20px;
  padding-left:20px;
  padding-top: 8px;
  height: 32px;
  overflow: hidden;
  text-overflow: clip;
  white-space: nowrap;
  font-weight: bold;
  color: #404040;
  background-color: #69d6ff;
}
.progressbar-text{
  font-weight: bold;
  color: #404040;
  text-align: right;
  width: 97%;
  position: relative;
  top: -30px;
}
.tag{
  color: #404040;
  border-radius: 10px;
  padding: 2px;
  display: inline-block;
  width: 100px;
  text-align: center;
}
.top1tag{
  background-color: #fcb434;
  border: solid 1px #fcb434;
}
.top2tag{
  background-color: #c0c0c0;
  border: solid 1px #c0c0c0;
}
.top3tag{
  background-color: #977547;
  border: solid 1px #977547;
}
.top4tag{
  border: solid 1px #fcb434;
}
.top5tag{
  border: solid 1px #c0c0c0;
}
.playerInTeam{
  height: 30px;
}
.animal-emoji{
  font-size: 1.5em;
  vertical-align: middle;
  line-height: 0;
  display: inline-block;
  height: 0;
  overflow: visible;
}
</style>